export default __webpack_public_path__ + "static/media/PEA.e0cf1558.jpeg";